import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-update-branch',
  templateUrl: './update-branch.component.html',
  styleUrls: ['./update-branch.component.scss']
})
export class UpdateBranchComponent implements OnInit {

  @ViewChild('successModal') successModal: any;

  LoaderComponent: any = '';
  multiDropdownSettings: any = {};
  multiSelectRegionDropdown: any = {};
  loginData: any;
  empID: any = "";
  regionArray: any = [];
  selectedRegion: any;
  selectedRegionList: any = [];
  selectedBranchList: any = [];
  branchMultiSelectItems: any = [];
  selectedBranch: any;
  empNameMultiSelectItems: any = [];
  singleSelectionDropdown: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  selectedEmployeeList: any = [];
  logeedInUser: any;
  branchDetails: any;
  updateUserBranchForm: FormGroup;
  hoursArray: any = [];
  minutesArray: any = [];
  allBranchIPs: any[] = [];
  branchIPData: any = {};
  allBranches: any[] = [];
  defaultAll: any;
  gridType: any = 'branch';
  matchedHeaders: any[] = [];
  headers: any[] = [];
  responseMessage: any;

  constructor(
    public service: WebRequestService,
    private loginDataStore: Data,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.hoursArray = this.bindHoursMinutes(0, 23, 'Hrs', 1)
    this.minutesArray = this.bindHoursMinutes(0, 59, 'Mins', 1)
    this.updateUserBranchForm = new FormGroup({
      startDate: new FormControl(''),
      startTime: new FormControl(''),
      endTime: new FormControl(''),
      endDate: new FormControl(''),
      macIpAddress: new FormControl('', [Validators.required]),
      isActive: new FormControl('')
    })
    this.loginDataStore.getStoreData('empData')
    .then((dataRes: any) => {
      this.loginData = JSON.parse(dataRes);
    })
    this.multiDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.multiSelectRegionDropdown ={
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    }
    this.singleSelectionDropdown = {
      singleSelection: true,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    }

    this.loadBasicData();
    this.allBranches = [
      {id: '', Value: 'All'},
      {id: '408', Value: 'AP'},
      {id: '409', Value: 'TN'},
      {id: '410', Value: 'KT'},
      {id: '1', Value: 'Other'}
    ];
    this.defaultAll = this.allBranches[0].id;
    this.branchIPData = {
      branchID: '',
      ipaddress: '',
      religionID: '',
      flag: ''
    }
    this.getAllBranchIP(this.branchIPData);
  }

  loadBasicData() {
    this.empID = sessionStorage.getItem('empId')
    this.service.getMasterData().then((response) => {
      if (response['statusCode'] === 200) {
        this.regionArray = response['result'][1];
        // this.selectedRegion = parseInt(this.loginData['region']);
        // this.selectedRegion1 = this.regionArray.filter(item => item.id == this.selectedRegion)
        this.selectedRegion = [this.getRegion(this.loginData['region'])]
        this.selectedRegionList.push(parseInt(this.loginData['region']))
        this.service.loadMasterDataWithId('StateLocation', this.loginData['region']).then((branchResult) => {
            this.branchMultiSelectItems = branchResult['result'];
            this.selectedBranch = [this.getBranch(this.loginData['branch'])];
          })
          .catch((err) => console.error(err));
        this.service.loadMasterDataWithId('ProfileOwnerbyBranch', parseInt(this.loginData['branch'])).then((empResult) => {
            this.empNameMultiSelectItems = empResult['result'];
            this.logeedInUser = [this.getEmployee(this.loginData['employeeID'])];

          })
          .catch((err) => console.error(err));
        // this.branchMultiSelectItems = response['result'][2];
        //  this.empNameMultiSelectItems = response['result'][4];
      }

    })



  }

  getAllBranchIP(branchIPData) {
    this.allBranchIPs = [];
    this.LoaderComponent = LoaderComponent;
    this.service.getBranchIPDetails(branchIPData).then((response) => {
      if (response['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.allBranchIPs = response['result'];
        this.prepareHeaders();
      }
    });
  }

  prepareHeaders() {
    this.matchedHeaders = [
      { title: 'Sno', value: 'SNO' },
      { title: 'Branch', value: 'branchName' },
      { title: 'IP Address', value: 'macAddressName' },
      { title: 'IP Address2', value: 'macAddressName_1' },
      { title: 'Update IP', value: 'update' },
    ]

    this.headers = ['SNO', 'branchName', 'macAddressName', 'macAddressName_1', 'update']
  }

  onBranchChange(event) {
    switch(event.value) {
      case '':
        this.branchIPData['religionID'] = '';
        break;
      case '408':
        this.branchIPData['religionID'] = 408;
        break;
      case '409':
        this.branchIPData['religionID'] = 409;
        break;
      case '410':
        this.branchIPData['religionID'] = 410;
        break;  
      case '1':
        this.branchIPData['religionID'] = 1;
        break;
    }
    this.getAllBranchIP(this.branchIPData);
  }

  bindHoursMinutes(fromval, Toval, str, incrementval) {
    let options = [];
    options.push({ label: str, title: str, value: "" });
    for (let i = fromval; i <= Toval; i += incrementval) {
      if (i < 10) {
        options.push({ label: "0" + i + " " + str, title: "0" + i + " " + str, value: +(parseInt(i) + 1) });
      } else {

        options.push({ label: i + " " + str, title: i + " " + str, value: +(parseInt(i) + 1) });
      }
    }
    return options;
  };

  getEmployee(id) {
    return this.empNameMultiSelectItems.find(val => {
      if (id == val.id) {
        return val;
      }
    })
  }
  getBranch(id) {
    return this.branchMultiSelectItems.find(val => {
      if (id == val.id) {
        return val;
      }
    })
  }
  getRegion(id) {
    return this.regionArray.find(val => {
      if (id == val.id) {
        return val.id;
      }
    })
  }

  getSelectedRegion(event) {
    if(this.selectedRegionList.indexOf(event.id) == -1) {
      this.LoaderComponent = LoaderComponent;
      this.branchMultiSelectItems = [];
      this.selectedRegionList.push(event.id);
      this.service
        .loadMasterDataWithId('StateLocation', this.selectedRegionList)
        .then((branchResult) => {
          if (branchResult['statusCode'] === 200) {
            this.LoaderComponent = "";
            this.selectedBranch = "";
            this.branchMultiSelectItems = branchResult['result'];
            this.logeedInUser = "";
            this.empNameMultiSelectItems = [];
          }
        })
        .catch((err) => {console.error(err)});
    }
  }

  onRegionDeSelect(event) {
    let index = this.selectedRegionList.indexOf(event.id);
    console.log('region',index)
    console.log(this.selectedRegionList)
      if (index > -1) {
        this.selectedRegionList.splice(index, 1);
        console.log(this.selectedRegionList)
        this.branchMultiSelectItems = [];
        this.service
          .loadMasterDataWithId('StateLocation', String(this.selectedRegionList))
          .then((empResult) => {
            this.branchMultiSelectItems = empResult['result'];
          })
  
      }
    
  }

  onRegionDeSelectAll(event) {
    this.selectedRegionList = event;
    this.branchMultiSelectItems = [];
  }

  onRegionSelectAll(event) {
    console.log(event)
    this.selectedRegionList = [];
    for (let i = 0; i < event.length; i++) {
      this.selectedRegionList.push(event[i]['id'])
    }
    this.branchMultiSelectItems = [];
    console.log('branch',this.selectedRegionList)
    this.service
      .loadMasterDataWithId('StateLocation', String(this.selectedRegionList))
      .then((empResult) => {
        this.branchMultiSelectItems = empResult['result'];
      })
  }

  onBranchItemSelect(event) {
    if (this.selectedBranchList.indexOf(event.id) > -1) {
      let index = this.selectedBranchList.indexOf(event.id);
      this.selectedBranchList.splice(index, 1);
    } else {
      this.empNameMultiSelectItems = [];
      this.selectedBranchList.push(event.id);
      this.service
        .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
        .then((empResult) => {
          this.empNameMultiSelectItems = empResult['result'];

        })
    }
  }

  onBranchItemDeSelect(event) {
    let index = this.selectedBranchList.indexOf(event.id);
    if (index >= 0) {
      this.selectedBranchList.splice(index, 1);
      this.empNameMultiSelectItems = [];
      this.service
        .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
        .then((empResult) => {
          this.empNameMultiSelectItems = empResult['result'];
        })

    }

  }

  onBranchDeSelectAll(event) {
    this.selectedBranchList = event;
    this.empNameMultiSelectItems = [];
  }
  onBrachItemsSelectAll(event) {
    this.selectedBranchList = [];
    for (let i = 0; i < event.length; i++) {
      this.selectedBranchList.push(event[i]['id'])
    }
    this.empNameMultiSelectItems = [];
    this.service
      .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.selectedBranchList))
      .then((empResult) => {
        this.empNameMultiSelectItems = empResult['result'];
      })
  }

  onNameItemSelect(event) {
    this.selectedEmployeeList.push(event['id'])
  }

  onNameItemDeSelect(event) {
    let index = this.selectedEmployeeList.indexOf(event.id);
    if (index >= 0) {
      this.selectedEmployeeList.splice(index, 1);
    }
  }

  getUserBranchIP() {
    const data = this.logeedInUser[0].id;
    this.LoaderComponent = LoaderComponent;
    this.service.getUserBranchDetails(data).then((res) => {
      if(res['statusCode'] === 200 || res['statusCode'] === 204) {
        this.LoaderComponent = '';
        console.log(res['result'], 'dfsd');
        this.branchDetails = res['result'];
        this.patchBranchDetails(this.branchDetails);
      }
    })
  }

  patchBranchDetails(data) {
    this.updateUserBranchForm.patchValue({
      macIpAddress: data.macIpAddress,
      isActive: data.isActive,
      endDate: data.endDate,
      startDate: data.startDate
    })
  }

  remainderChange(event) {
    const dt = event.target.value;
    const dd = dt.getDate();
    const mm = dt.getMonth() + 1;
    event.targetElement.value = `${dd > 10 ? dd : '0' + dd} / ${mm > 10 ? mm : '0' + mm
      } / ${dt.getFullYear()}`;
  }

  _convertDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    month.length < 2 ? (month = '0' + month) : month;
    day.length < 2 ? (day = '0' + day) : month;

    return [month, day, year].join('/');
  }

  updateWorkFromHomeIP() {
    const data = {
      empID: this.logeedInUser[0].id,
      macIpAddress: this.updateUserBranchForm.value.macIpAddress.trim(),
      startDate: this.updateUserBranchForm.value.startDate ? this._convertDate(this.updateUserBranchForm.value.startDate) : null,
      endDate: this.updateUserBranchForm.value.endDate ? this._convertDate(this.updateUserBranchForm.value.endDate) : null,
      isActive: this.updateUserBranchForm.value.isActive
    }
    this.LoaderComponent = LoaderComponent;
    this.service.updateUserBranchIP(data).then((res) => {
      if(res['statusCode'] === 200) {
        const trackingActivityData = {
          Application: 'E',
          RoleId: this.loginData['empTypeID'],
          Event: 'Update IP',
          Module: 'Admin forms',
          EventOutcomeIndicator: `Updated work from home IP for employee ${this.logeedInUser[0].value}`,
          IPAddress: this.loginData.ipAddress
        };
        this.service.getActivityTracking(trackingActivityData).then((res) => {
          console.log(res);
        });
        this.LoaderComponent = '';
        this.responseMessage = res['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 2000);
      } else {
        this.LoaderComponent = '';
        this.responseMessage = res['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 2000);
      }
    })
  }

  redirectToPagePermission(selectedRegion, selectedBranch, logeedInUser) {
    const data = {
      region: selectedRegion,
      branch: selectedBranch,
      user: logeedInUser
    }
    console.log(data.toString());
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`employee-permission`], {queryParams: {emp: JSON.stringify(data)}})
    );
    window.open(url, '_blank')
  }

}
